var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.15126 3.28118V0.95531C9.15126 0.569321 9.37604 0.220784 9.7202 0.0725028C10.0644 -0.0750138 10.4601 0.00676995 10.724 0.279638L15.7302 5.47177C16.0898 5.84476 16.0898 6.45012 15.7302 6.82311L10.724 12.0152C10.4601 12.2881 10.0644 12.3699 9.7202 12.2224C9.37604 12.0741 9.15126 11.7256 9.15126 11.3396V9.0137H7.52993C5.59317 9.0137 3.76917 9.95918 2.60696 11.5666L1.30253 13.3704C1.15955 13.5676 0.911196 13.6486 0.685683 13.5707C0.46017 13.4919 0.307617 13.2733 0.307617 13.0265V12.2621C0.307617 7.30235 4.18482 3.28118 8.96702 3.28118H9.15126ZM1.48014 11.2142L1.7226 10.8787C3.09336 8.98312 5.24532 7.86719 7.52993 7.86719H9.70399C10.0091 7.86719 10.2567 8.12401 10.2567 8.44044V10.8779L14.8178 6.14744L10.2567 1.41697V3.85443C10.2567 4.17087 10.0091 4.42768 9.70399 4.42768H8.96702C5.13772 4.42768 1.97391 7.3826 1.48014 11.2142Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendIcon);
export default __webpack_public_path__ + "static/media/resend_icon.488b269993e76b8e141d9bca52a64756.svg";
export { ForwardRef as ReactComponent };